import { mapGetters,mapActions } from "vuex";
import { types as Home } from "@/store/home";
import { types as Vi } from "@/store/vi";
import location from "@/components/location.vue";
import goodsType from "@/components/goodsType.vue";
import { uleUrl,checkUserStatus ,getCookie,scExposure,systemTime } from "@/libs/common";
import { adCart,queryCouponList,indexDate1, indexDate2,isNewUser,getNewIndexBanner, getIndexBanner2 ,activityNew,PilotCity,checkCart,DayHotGood,SecKillGood,acvtivityInfo,serchCoupon,pilotCityList,historySite,getAllCoupon,pilotCityListNew,getPilotCityMiddleBanners,editCart,deleteCart,isNewUserForVI,getIndexDefSiteApi ,getCartItemByIdApi,addOrUpdateApi,freshHomePopApi,lottryV2Api,queryActCodeByUsrRoleAndThemeCodeApi,queryActCodeByThemeCodeApi,freshPopAndFloatApi } from "@/libs/api.js";
const getters = mapGetters({
  getCurrentCity: Home.CURRENT_CITY,
  getCurrentAdCode: Home.AD_CODE,
  getCurrentCityByMin: Home.CURRENT_CITY_MIN,
  getCurrentAdCodeByMin: Home.AD_CODE_MIN,
});
const actions = mapActions({
  setPioltCity: Home.IS_PIOLICity,
  setCartNumber: Home.CART_NUMBER,
  getGoodsDetail: Vi.GOODS_DETAIL,
  setCartNumber: Home.CART_NUMBER,
});
export default {
  name: "Home",
  components: { location, goodsType },
  data() {
    return {
      searchValue: "",
      adcode: "",
      topBanner: [],
      categoryItem: null,
      categoryBoxH: 0,
      pageShow: false,
      productData: [],
      shareId: "",
      store_id:'',//同vi页面值
      batchidList:[],//优惠券批次号信息和数量  领取用
      batchidCheckListL:'',//优惠券批次号信息和数量  领取用
      isNewUserFlag:false,//是否是新用户
      ispioltCity:false,//是否是试点城市
      pilotCityList:[],//试点城市列表
      mapHref: "https://apis.map.qq.com/tools/locpicker?search=1&type=0&key=OTHBZ-3VGKV-UU4P3-ULQNZ-7DPSS-KOFT4&referer=myapp",
      siteImg: `https://i0.${process.env.VUE_APP_HOST_CDN}/ulewap/i/ylxdsq/siteImg.png`,
      querySiteParams:{
        longitude:'',//经度 121.586118
        latitude:'',//纬度  31.29371
        radius:'100',//查询半径   	默认查询距离50公里
        areaId:'',//定位区
        cityId:'',//定位市
        provinceId:'',//定位省
        sort:'0',//排序字段   网点按距离远近排序。0:升序（默认）, 1:降序
        siteKeyword:'',//搜索关键字  浦东新区浦江东旭公寓
        pageIndex:'1',//页号
        pageSize:'10',//每页显示数
        teamFlag:'2',
        teamUserId:''
      },
      consigneeName:'',
      mobileNum:'',
      cityName:'',
      ispiolt:false,
      sitePop:false,
      loading: false,
      finished: false,
      isClick:false,
      actiBanner1:[],//
      actiBanner2:[],//默认banner
      actiBanner3:[],// 试点城市首页指定banner
      couponCode:'',
      discountActivityCode:'',//新人礼2活动code
      discountThemeCode: '',//限时抢购主题code
      newRuleCode:'',// 促销前置code
      couponBatchIds:'',//新人礼1领券领取信息
      activityNewArr:[],//新人专享礼2商品数组
      secKillTime:[],//秒杀商品时间点
      seckillIndex:0,//秒杀显示
      nowTime:0,//当前时间
      couponList:[],//优惠券信息
      dayHotList:[],//每日爆品
      siteData:{},//选择的试点城市
      siteList:"",//自提点列表
      historySite:'',//历史自提点
      freshActType:'',
      prodItems: false,
      popData: {
        listName: "",
        price: "",
        mkPrice: "",
        colors: [],
        sellNum: 12, // 接口数据缺失
        prodCount: 1, //起购数量  //接口数据缺失
        minNum: 1, // 接口数据缺失
        defItemId: "",
      },
      popActive: 0,
      sizeActive: 0,
      limit: false,
      storage: 100,
      minMessage: {
        title: "",
        desc: "",
        link: "",
        imgUrl: "",
      },
      curCityCode:'',
      isNewCustomer:false,//是否为新人用户
      newSecKillList:[],
      myPoint:'',
      listStatus:0,
      targetUrl: `https://h5.${this.$uleUrl()}/yxd/community`,
      ylyx_commodity_current_price:'',
      ylyx_commodity_original_price:'',
      isLogin:false, // 是否登录
      isShowEnvelopes:false, // 红包抽奖弹层
      isShowRedIcon:false, // 红包浮层
      activityCode: '', // 红包code
      activityStartTime: '', // 抽红包开始时间
      activityEndTime: '', // 抽红包结束时间
      canLottry:false, // 是否抽过
      isSuccess:false, // 是否抽中
      prizeData:{}, // 中奖信息
      resultText:'', // 未中提示
      isLast:false, // 活动是否最后一天
      floatImg: '', // 红包雨图片
      floatUrl: '', // 红包雨链接
      rainTime: '',
      rainImg: '',
      rainUrl: '',
      isShowNew: false,
      newData: '',
      systemTime:null,

    };
  },
  computed: {
    ...getters,
  },
  methods: {
    ...actions,
    getCartNumbers(){
        let params = {}
        if(this.ispioltCity){
          params.cartType = '12'
        }
        checkCart(params,"jsonCallback").then((data) => {
          if (data.data === "0") {
            data.data = null;
          }
          this.setCartNumber(data.data)
        });
    },
        // 加入购物车
    popCart(listId,isNoStart,itemInfo,list,index,type) {
      // console.log('itemInfo=',itemInfo)
      let userOnlyId = this.getStorage("user", "user.STORE_ID");
      if(userOnlyId){
        if (isNoStart) {
          this.$toast('活动未开始');
          return false
        }
        // 获取商品信息
        this.getGoodsDetail(listId).then((res) => {
          this.popData = Object.assign(this.popData, res);
          // 图片处理
          if (~this.popData.imgUrl.indexOf("http://")) {
            this.popData.imgUrl = this.popData.imgUrl.replace("http://", "https://");
          }
          this.storage = this.popData.colors[0].items[0].itemStorage;
          itemInfo.storage = this.popData.colors[0].items[0].itemStorage;
          itemInfo.limitNum = this.popData.limitNum;
          itemInfo.prodCount = 1;
          itemInfo.limitWay = this.popData.limitWay;
          if (this.popData.limitWay == 0 || this.popData.limitWay > 7) {
            //不限购
            this.popData.prodCount = 1;
            this.popData.minNum = this.popData.limitNum;
            itemInfo.minNum = this.popData.limitNum;
            
          } else if (this.popData.limitWay == 4) {
            // 起售
            this.popData.minNum = this.popData.limitNum;
            itemInfo.minNum = this.popData.limitNum;
          }
          this.popData.colors.map((item, index) => {
            item.items.map((sItem, sindex) => {
              if (sItem.itemId == this.popData.defItemId) {
                this.popActive = index;
                this.sizeActive = sindex;
                this.popData.sharePrice = sItem.membershipPrice || sItem.itemSalPrice;
              }
            });
          });
          if(this.popData.colors.legnth > 1){
            itemInfo.multi = 2;
          }
          else{
            // itemInfo.multi = 1;
            this.popData.colors.forEach(ele=>{
              if(ele.items.length > 1){
                itemInfo.multi = 2;
              }
            })
          }
          // 多规格
          if(itemInfo.multi == 2){
            this.prodItems = true;
          }else{
           this.handleAddCart(itemInfo,list,index,type)
          }
        });
      }else{
        // this.$toast('请登录')
        this.handleToLogin()
      }
     
    },
    handleToLogin() {
      this.targetUrl = `${this.targetUrl}${this.$route.fullPath}`;
      this.$dialog
        .confirm({
          title: "提示",
          message: "请先登录",
        })
        .then(() => {
          if (this.$browser().miniprogram) {
            window.wx.miniProgram.navigateTo({
              url:
                "/pages/authorize?target=" +
                encodeURIComponent(this.targetUrl) +
                "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
            });
          } else {
            window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(
              this.targetUrl
            )}`;
          }
        })
        .catch(() => {});
    },
    // 切换颜色
    changColor(index, itemId, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.popActive = index;
      }
      if (this.sizeActive >= this.popData.colors[index]["items"].length) {
        this.sizeActive = this.popData.colors[index]["items"].length - 1;
        this.popData.defItemId = this.popData.colors[index]["items"][this.sizeActive].itemId;
      }
      this.popData.defItemId = this.popData.colors[index]["items"][this.sizeActive].itemId;
      this.storage = this.popData.colors[index]["items"][this.sizeActive].itemStorage;
      //this.maxPrice、this.price 如果有一品多价也在此处处理
      this.popData.sharePrice = this.popData.colors[index]["items"][this.sizeActive].membershipPrice||this.popData.colors[index]["items"][this.sizeActive].itemSalPrice;
      this.popData.marketPrice = this.popData.colors[index]["items"][this.sizeActive].itemMarketPrice;
    },
    // 切换规格
    changSize(index, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.sizeActive = index;
        this.popData.defItemId = e.target.getAttribute("itemId");
        this.storage = e.target.getAttribute("storage");
        //this.maxPrice、this.price 如果有一品多价也在此处处理
        this.popData.sharePrice = this.popData.colors[this.popActive]["items"][index].membershipPrice || this.popData.colors[this.popActive]["items"][index].itemSalPrice;
        this.popData.marketPrice = this.popData.colors[this.popActive]["items"][index].itemMarketPrice;
        this.ylyx_commodity_current_price = this.popData.colors[this.popActive]["items"][index].itemSalPrice;
        this.ylyx_commodity_original_price = this.popData.colors[this.popActive]["items"][index].itemMarketPrice;
        if (this.limit) {
          // 商品有限购
          if (Number(this.popData.limitNum) > Number(this.storage)) {
            //限购数量超出库存时取最小
            this.popData.limitNum = this.storage;
          } else {
            // this.limitNum = limitNum
          }
        } else {
          this.storage = e.target.getAttribute("storage");
          if (Number(this.popData.minNum) > Number(this.storage)) {
            // 最少购买数大于库存 ,团购商品存在这个问题
            this.$toast("商品已售罄");
            this.prodCount = this.storage;
          }
        }
      }
      if (Number(this.prodCount) > Number(this.storage)) {
        this.popData.prodCount = this.storage;
      }
    },
    // 试点城市首页跳回优鲜首页
    skipFreshHome(action){
       window.location.href = window.location.href+'&'+action;
    },
    // 分类跳转
    onCategory(categoryId) {
      this.toNext("/category/categoryList", { categoryId: categoryId });
      this.$emit("tabChange", "categoryList");
    },
    // 商品详情页跳转
    viPage(listId,item,index,type) {
      console.log('参数参数参数参数参数',this.$route.query)
      let ylyx_resource_forward_url='';
      // H5
      if (this.$route.query.name) {
        this.$router.push({
          path: "/item/itemPage/" + listId,
          query: { name: this.$route.query.name, latng: this.$route.query.latng, addr: this.$route.query.addr, city: this.$route.query.city, module: this.$route.query.module,freshActType:this.freshActType },
        });
        ylyx_resource_forward_url=`/item/itemPage/${listId}?name=${this.$route.query.name}&latng=${this.$route.query.latng}&addr=${this.$route.query.addr}&city=${this.$route.query.city}&module=${this.$route.query.module}&freshActType=${this.freshActType}`;
      } else {
        this.$router.push({
          path: "/item/itemPage/" + listId,
          query: {freshActType:this.freshActType }
        });
        ylyx_resource_forward_url=`/item/itemPage/${listId}?freshActType=${this.freshActType}`;
      }
      let ylyx_resource_type={
        '1':'新人礼',
        '4':'限时秒杀',
        '6':'每日爆品',
      };
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_ResourceClick', {
				ylyx_resource_ower: '试点版',
				ylyx_resource_type: ylyx_resource_type[type],
				ylyx_resource_content: item.title,
				ylw_resource_out_position: type,
				ylw_resource_inner_position: (+index + 1),
				ylyx_resource_item_type: '商品',
				ylyx_resource_item_id: listId || '',
				ylyx_resource_forward_url: ylyx_resource_forward_url,
			});
    },
    sensorSource(image,index,type){
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_ResourceClick', {
				ylyx_resource_ower: '试点版',
				ylyx_resource_type: '腰部广告位',
				ylyx_resource_content: image.title || '',
				ylw_resource_out_position: type,
				ylw_resource_inner_position: (+index + 1),
				ylyx_resource_item_type: 'Banner',
				ylyx_resource_item_id: '',
				ylyx_resource_forward_url: image.h5_action,
			});
    },
    
    // 加入购物车
    addCart(item,isNoStart) {
      if (isNoStart) {
        this.$toast('活动未开始');
        return false
      }
      let data = {
        listId: item.listId || item.listingId,
        itemId: this.popData.defItemId || this.popData.itemId,
        itemCount: this.popData.prodCount,
        yxdId: this.store_id, //用户id
      };
      if(this.freshActType == 1){
        data.cartType = '12'
      }
      adCart(data, "jsonCallback").then((res) => {
        if (res.returnCode === "0000" || res.code === "0000") {
          // console.log(res,'加入购物车')
          this.prodItems = false;
          this.setCartNumber(res.data)
        }
        this.$toast(res.returnMessage);
      });
      //神策埋点
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_AddCart', {
        ylyx_commodity_sku_code: this.popData.defItemId || this.popData.itemId,
        ylyx_commodity_name: this.popData.listName || '',
        ylyx_commodity_original_price: this.ylyx_commodity_original_price || this.popData.marketPrice,
        ylyx_commodity_current_price: this.ylyx_commodity_current_price || this.popData.sharePrice,
        item_id: item.listId || item.listingId,
        ylyx_commodity_count: this.popData.prodCount,
      });
    },
    // 首页加入购物车
    handleAddCart(item,list,index,type){
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      // console.log('list=======',list)
      let params = {
        itemIds:item.itemId,
        cartType:'12'
      }
      // 获取此商品在购物车中的数量
      getCartItemByIdApi(params,'jsonCallback').then(res=>{
          console.log(res.data)
          if(res.code == '0000'){
            // 从未添加过购物车
            if(JSON.stringify(res.data) == "{}"){
              let data = {
                listId: item.listId || item.listingId,
                itemId: item.itemId,
                itemCount: 1,
                yxdId: this.store_id, //用户id
              };
              if(this.freshActType == 1){
                data.cartType = '12'
              }
                // 加入购物车
                adCart(data, "jsonCallback").then((res) => {
                  if (res.returnCode === "0000" || res.code === "0000") {
                    item.multi = 1;
                    list.splice(index,1,item)
                    this.prodItems = false;
                    this.setCartNumber(res.data)
                  }else{
                    item.multi = 0;
                    list.splice(index,1,item)
                  }
                  this.$toast(res.returnMessage);
                });
            }
            // 已添加过
            else{
                    let currentItem = res.data[item.itemId];
                    item.prodCount = currentItem.prdCount + 1;
                    item.itemType = currentItem.itemType;
                    item.multi = 1;
                    list.splice(index,1,item);
                    // 爆品商品
                    if(type == 'bao'){
                      console.log('item.storage===',item)
                      if(item.dayLimitNum > 0){
                        if(item.prodCount > item.hotMax){
                          return this.$toast(`最多只能添加${item.hotMax}件`)
                        }
                      }else{
                        if(item.prodCount > item.storage){
                          return this.$toast(`最多只能添加${item.storage}件`)
                        }
                      }
                    }else if(type == 'miao' || type == 'xin'){
                      console.log('dayLimitNum=====',item.dayLimitNum)
                      console.log('prodCount11111111==',item.prodCount)
                      if(item.prodCount > item.dayLimitNum){
                        item.prodCount = item.dayLimitNum;
                        return this.$toast(`最多只能添加${item.dayLimitNum}件`)
                      }
                    }
                    this.$toast.clear();
                    // console.log('item.currentItem.prdCount===',item.prodCount)
                    // console.log('item.prodCount===',item.prodCount)
                    this.updateCarNum(item,list,index)
              // console.log('createTime===',res.data[item.itemId].createTime)
            }
          
        }else{
          // this.$toast('请登录')
          this.handleToLogin()
        }
      })
      
      
      
    },
    // 首页更改数量秒杀
    handleUpdateCar(item,list,index){
      this.$toast.loading({
        duration: 0,
        mask: true,
        message: "加载中...",
      });
      // console.log('prodCount',item.prodCount)
      // 添加
      if(item.limitWay == 0){
        if(item.prodCount > item.dayLimitNum){
          item.prdCount = item.dayLimitNum;
          console.log('item.prdCount====',item.prdCount)
          list.splice(index,1,item);
          return this.$toast(`最多只能添加${item.dayLimitNum}件`)
        }
      }
      if(item.prodCount > 0){
        this.updateCarNum(item,list,index)
      }
      // 删除
      else{
        item.multi = 0;
        list.splice(index,1,item)
        this.deleteCar(item)
      }
    },
    // 首页更改数量爆品
    handleBaoUpdateCar(item,list,index){
      this.$toast.loading({
        duration: 500,
        mask: true,
        message: "加载中...",
      });
      // console.log('prodCount',item.prodCount)
      // 添加
      if(item.prodCount > 0){
        this.updateCarNum(item,list,index)
      }
      // 删除
      else{
        item.multi = 0;
        list.splice(index,1,item)
        this.deleteCar(item)
      }
    },
    // 首页加减购物车商品
    updateCarNum(item,list,index){
      let params = {
        itemId: item.itemId,
        itemCount: item.prodCount,
        yxdId: this.store_id,
        listId: item.listId || item.listingId,
        userId: this.getStorage("user", "user.STORE_ID"),
      };
      console.log('item=====',item)
      console.log('prodCount=====',item.prodCount)
      console.log('params===',params)
      if(this.freshActType == '1') params.cartType = '12'
      editCart(params, "jsonCallback").then((res) => {
        if (res.returnCode === "0000") {
          item.multi = 1;
          // console.log('list====',list)
          list.splice(index,1,item);
          this.$toast("更新成功");
          // this.$toast.clear();
          this.prodItems = false;
          this.getCartNumbers();
        }else{
          this.$toast(res.returnMessage);
          item.prodCount = (item.prodCount - 1).toString();
          list.splice(index,1,item);
          // console.log('list',list)
          this.prodItems = false;
        }
      });
    },
    // 首页删除购物车
    deleteCar(item){
      let params = {
				listId: item.listId || item.listingId,
				itemId: item.itemId,
				itemType: item.itemType || '',
				yxdId: this.store_id,
				userId: this.getStorage("user", "user.STORE_ID"),
			};
			if(this.freshActType == 1){
				params.cartType = '12'
			}
			deleteCart(params, "jsonCallback").then((res) => {
				if (res.returnCode === "0000") {
					this.$toast("更新成功");
          checkCart({cartType:'12'},"jsonCallback").then((data) => {
            if (data.data === "0") {
              data.data = null;
            }
            this.setCartNumber(data.data)
          });
				}
			});
    },
    toserch(){
      if(this.freshActType == '1'){
        this.toNext('/search/searchList',{freshActType:1})
      } else {
        this.toNext('/search/searchList')
      }
    },
    // 获取首页数据
    getPageData(adcode) {
      indexDate1(adcode, "jsonp1").then(
        (res) => {
          if (res.code === "0000") {
            let banner = res.banner || [];
            banner.forEach(ban => {
              if (ban.visibleToApplets != '0') {// ==0  优鲜小程序不展示
                this.topBanner.push(ban)
                //监听资源位曝光
                this.$nextTick( () => {
                  let _this=this;
                  scExposure(".banner_1_item",function(index){
                    console.log('=======当前曝光的资源位',_this.topBanner[index])
                    window.uleStatUtil && window.uleStatUtil.sendSensorTrack("ylyx_ResourceExposure", {
                      ylyx_resource_ower:'非试点版',
                      ylyx_resource_type: '首页轮播图',
                      ylyx_resource_content: _this.topBanner[index].title || '',
                      ylw_resource_out_position: 1,
                      ylw_resource_inner_position: (+index + 1),
                      ylyx_resource_item_type: 'Banner',
                      ylyx_resource_item_id: '',
                      ylyx_resource_forward_url: _this.topBanner[index].customAtt_link,
                      ul_aid:`yxhome_banner_${_this.topBanner[index].title || _this.topBanner[index].customTitle || ''}`
                    });
                  });
                })
              }
            });
            if (res.category.length <= 0) {
              return false;
            }
            let datas = res.category;
            if (res.category.length > 5) {
              this.categoryBoxH = 200;
            } else {
              this.categoryBoxH = 100;
            }
            this.categoryItem = this.cutArr(datas, 10);
            this.pageShow = true;
          } else {
            this.$toast(res.msg);
          }
        },
        () => {
          console.log("接口错误");
        }
      );
      indexDate2(adcode, "jsonp2").then(
        (res) => {
          if (res.code === "0000") {
            this.$toast.clear();
            let groupsortList = []; // 存入所有groupsort
            let groupsortArray = [];// 去重后存放groupsort
            let productList = res["today_best_product"];
            if (productList.length > 0) {
              // 先获取所有groupsort的值 
              productList.forEach(item => {
                groupsortList.push(item.groupsort);
              });
              // 获取去重后的groupsort
              for (let i = 0; i < groupsortList.length; i++) {
                if (groupsortArray.indexOf(groupsortList[i]) == -1) {
                  groupsortArray.push(groupsortList[i]);
                }
              };
              // 重新组合相同groupsort值的商品
              groupsortArray.forEach((item) => {
                this.productData.push(this.getObjs(productList, 'groupsort', item))
              });
            }
            // this.productData = [];
            // productList.map((item) => {
            // 	if (!this.productData[item.groupsort - 1]) {
            // 		this.productData[item.groupsort - 1] = [];
            // 	}
            // 	if (~item.customImgUrl.indexOf("http://")) {
            // 		item.customImgUrl = item.customImgUrl.replace("http://", "https://");
            // 	}
            // 	this.productData[item.groupsort - 1].push(item);
            // });
            this.pageShow = true;
          } else {
            this.$toast(res.msg);
          }
        },
        () => {
          console.log("接口错误");
        }
      );
    },
    // 获取首页相应商品
    getObjs(arry, key, value) {
      var result = [];
      arry.forEach(item => {
        if (~item.customImgUrl.indexOf("http://")) {
          item.customImgUrl = item.customImgUrl.replace("http://", "https://");
        }
        if (item[key] === value) {
          result.push(item)
        }
      });
      return result;
    },
    // 拆分数据方法
    cutArr(arr, num) {
      num = num * 1 || 1;
      var retArr = [];
      arr.forEach(function (item, i) {
        if (i % num === 0) {
          retArr.push([]);
        }
        retArr[retArr.length - 1].push(item);
      });
      return retArr;
    },
    // 获取试点城市自提点
    selfPickupSite(adcode) {
      let that = this;
      if (that.isClick) {
        return false
      }
      that.isClick = true
      console.log('adcodeadcodeadcodeadcodeadcode',adcode)
      if(adcode) this.querySiteParams.cityId = adcode//转换成市code
      // 如果有经纬度，则城市code为空
      if(this.querySiteParams.latitude && this.querySiteParams.longitude){
        // this.querySiteParams.cityId = '';
        // this.querySiteParams.areaId = '';
      }
      // 获取试点城市自提点列表
      pilotCityList(this.querySiteParams,'site').then((res)=>{
        that.isClick = false        
        that.loading = false
        if(res.data && res.data.result){
          that.listStatus = 1;
          if (that.querySiteParams.pageIndex > 1) {
            that.siteList = that.siteList.concat(res.data.result);
          }else{
            that.siteList = res.data.result;
          }
        }else{
          that.siteList = [];
          that.listStatus = 2;
        }
        if(res.data && res.data.result){
          if(res.data.result.length) this.cityName = res.data.result[0].cityName.replace('市','')
        }
        if (!res.data || that.querySiteParams.pageIndex >= res.data.totalPages) {
          that.finished = true
        }
        // 历史自提点列表
        historySite({teamFlag:2},'historySite').then((his)=>{
          if (his.code == '0000' && his.data.result.length>0) {
            // const hisSite = his.data.result[his.data.result.length-1];
            const hisSite = his.data.result[0];
            that.historySite = hisSite
            that.mobileNum = hisSite.mobileNum;
            that.consigneeName = hisSite.consigneeName;
            // for (let h = 0; h < his.data.result.length; h++) {
            //   const hisSite = his.data.result[h];
            //   // console.log('this',this.querySiteParams.areaId)
            //   // console.log('adcode====',adcode)
            //   // console.log('this.querySiteParams.areaId====',this.getCurrentAdCode)
            //   // if (this.querySiteParams.areaId == hisSite.areaId) {//历史下单自提点在一个区
             
            //   let currentAreaId = '';
            //   if (this.$browser().miniprogram) {
            //     currentAreaId = this.getCurrentAdCodeByMin;
            //   }else{
            //     currentAreaId = this.getCurrentAdCode;
            //   }
            //   // console.log('hisSite.areaId===',hisSite.areaId)
            //   if (currentAreaId == hisSite.areaId) {// 历史下单自提点在一个区
            //     that.historySite = hisSite
            //     that.mobileNum = hisSite.mobileNum;
            //     that.consigneeName = hisSite.consigneeName;
            //     break
            //   }
            // }
          }
          if(adcode){
            that.siteData = that.historySite || that.siteList[0] || {}
            // console.log('that.siteData======',that.siteData)
            // console.log('consigneeName======',that.consigneeName)
            let selectSite = {
              location: that.siteData.geoPoint,
              siteId: that.siteData.siteId,
              adcode:that.siteData.areaId,
              mobileNum:that.siteData.mobileNum,
              consigneeName:that.siteData.consigneeName
            }
            // console.log('selectSite====',selectSite)
            document.cookie = `selectSite=${JSON.stringify(selectSite)};domain=.${uleUrl()};path=/;`;
            // that.getPageData(adcode);
          }
           // 以接口的自提点为主
          getIndexDefSiteApi().then(res=>{
            var that = this;
            if(res.data){
              console.log('获取最后一次自提点信息',res.data.result);
              // 如果有自提点信息
              if(res.data.result.length > 0){
                this.myPoint = res.data.result[0];
                let last = res.data.result[0];
                that.siteData = last || {}
                let selectSite = {
                  location: last.geoPoint,
                  siteId: last.siteId,
                  adcode:last.areaId,
                  mobileNum:last.mobileNum,
                  consigneeName:last.consigneeName
                }
                document.cookie = `selectSite=${JSON.stringify(selectSite)};domain=.${uleUrl()};path=/;`;
              }
              else{
                console.log('siteData===t',this.siteData)
                let selectSite = {
                  location: this.siteData.geoPoint,
                  siteId: this.siteData.siteId,
                  adcode:this.siteData.areaId,
                  consigneeName:this.siteData.consigneeName,
                  mobileNum:this.siteData.mobileNum,
                }
                addOrUpdateApi(selectSite).then(res=>{
                  // console.log('res===',res)
                  console.log('之前没有自提点，自提点更新成功')
                })
              }
            }
          })
        });
       
      },()=>{
        that.isClick = false
      })
    },
    searchSite(){//查询自提点
      if (this.querySiteParams.siteKeyword) {
        this.loading = true
        this.finished = false
        this.querySiteParams.pageIndex = 1
        this.selfPickupSite()
      }
    },
    moreSite(){//加载更多
      if (this.isClick) {
        return false
      }
      this.querySiteParams.pageIndex++
      this.selfPickupSite()
    },
    // 点击选择自提点
    selectSite(site){
      console.log(site)
      this.siteData = site
      let selectSite = {
        location: this.siteData.geoPoint,
        siteId: this.siteData.siteId,
        adcode:this.siteData.areaId,
        consigneeName:this.siteData.consigneeName,
        mobileNum:this.siteData.mobileNum,
      }
      addOrUpdateApi(selectSite).then(res=>{
        // console.log('res===',res)
        console.log('自提点更新成功')
      })
      document.cookie = `selectSite=${JSON.stringify(selectSite)};domain=.${uleUrl()};path=/;`;
      this.closePop()
    },  
    // 跳转至手动切换地址
    toSelectAddress() {
      // 小程序跳转
      if (this.$browser().miniprogram) {
        let indexPick = `https://h5.${this.$uleUrl()}/yxd/community/others/indexPick`;
        window.wx.miniProgram.navigateTo({
          url: `/pages/map/map?targetUrl=${indexPick}`
        });
        return false;
      }
      // H5跳转
      else {
        let href = `${window.location.origin}/yxd/community/others/indexPick`;
        console.log('href=======',href)
        this.mapHref = this.mapHref + `&backurl=${encodeURIComponent(href)}`;
        window.location.href = this.mapHref;
      }
    },    
    closePop(){
      this.sitePop = false
    },
    openPop(){
      this.querySiteParams.pageIndex = 1;
      this.querySiteParams.siteKeyword = '';
      this.loading = true
      this.finished = false;
      this.listStatus = 0;
      this.siteList = [];
      this.selfPickupSite()
      this.sitePop = true
    },
    // 点击显示秒杀
    chooseSec(index){
      this.seckillIndex = index
    },
    // 判断是否是新人用户，此接口会给用户推送资格
    isNew(){
      let params = {
        'discountActivityCode': this.couponCode,
        'newActivtyCode': this.discountActivityCode,
        'newRuleCode': this.newRuleCode
      }
      isNewUser(params).then(
        (res) => {
          if(res.code == '0000'){
            this.isNewUserFlag = res.data.new
          }
          // console.log(res, '判断新人接口')
        },
        () => {
          // console.log('接口错误')
        }
      )
    },
    //获取新版首页banner
    getNewBanner(adcode){
      getNewIndexBanner(adcode).then(
        (res) => {
          if(res.code == '0000'){
            this.actiBanner1 = res.banner1
            // this.actiBanner2 = res.banner2
            this.$nextTick(()=>{
              let _this=this;
              scExposure(".sensor_banner2",function(index){
                window.uleStatUtil && window.uleStatUtil.sendSensorTrack("ylyx_ResourceExposure", {
                  ylyx_resource_ower:'试点版',
                  ylyx_resource_type: '腰部广告位',
                  ylyx_resource_content: _this.actiBanner1[index].title || '',
                  ylw_resource_out_position: 2,
                  ylw_resource_inner_position: (+index + 1),
                  ylyx_resource_item_type: 'Banner',
                  ylyx_resource_item_id: '',
                  ylyx_resource_forward_url: _this.actiBanner1[index].h5_action,
                });
              });
            })
          }
          // console.log(res, '首页banner接口')
        },
        () => {
        }
      )
    },
    //获取新版首页banner2
    getNewBanner2(adcode){
      getIndexBanner2({'key':'ylyx_xcx_sd_head_banner','adcode':adcode}).then(
        (res) => {
          if(res.code == '0000' && res.data.length>=1){
            console.log('111====',res.data)
            this.actiBanner2 = res.data
            //监听资源位曝光
            this.$nextTick(()=>{
              let _this=this;
              scExposure(".sensor_banner3",function(index){
                window.uleStatUtil && window.uleStatUtil.sendSensorTrack("ylyx_ResourceExposure", {
                  ylyx_resource_ower:'试点版',
                  ylyx_resource_type: '腰部广告位',
                  ylyx_resource_content: _this.actiBanner2[index].title || '',
                  ylw_resource_out_position: 3,
                  ylw_resource_inner_position: (+index + 1),
                  ylyx_resource_item_type: 'Banner',
                  ylyx_resource_item_id: '',
                  ylyx_resource_forward_url: _this.actiBanner2[index].h5_action,
                });
              });
            })
          }
          // console.log(res, '首页banner2接口')
        },
        () => {
        }
      )
    },
    // 试点城市中间banner
    getPilotMiddleBanners(adcode){
        getPilotCityMiddleBanners(adcode).then(
        (res)=>{
          if(res.code == '0000' && res.data.length>=1) {
            this.actiBanner3 = res.data;
            //监听资源位曝光
            this.$nextTick(()=>{
              let _this=this;
              scExposure(".sensor_banner4",function(index){
                window.uleStatUtil && window.uleStatUtil.sendSensorTrack("ylyx_ResourceExposure", {
                  ylyx_resource_ower:'试点版',
                  ylyx_resource_type: '腰部广告位',
                  ylyx_resource_content: _this.actiBanner3[index].title || '',
                  ylw_resource_out_position: 5,
                  ylw_resource_inner_position: (+index + 1),
                  ylyx_resource_item_type: 'Banner',
                  ylyx_resource_item_id: '',
                  ylyx_resource_forward_url: _this.actiBanner3[index].h5_action,
                });
              });
            })
          }
        })
      
    },
    siteTagName(tagName){
      if (tagName) {
        let htm = '',arr=[];
        arr = tagName.split(',')
        for (let t = 0; t < arr.length; t++) {
          htm += `<span>${arr[t]}</span>`
        }
        return htm
      }
      return ''
    },
    getactivityNew(){//新人专享礼2商品
      const params = {
        activityNo:this.discountActivityCode,
        pageSize:50,
        pageNum:1
      }
      activityNew(params).then(
        (res) => {
          if(res.code == '0000' && res.content.itemList){
            this.activityNewArr = res.content.itemList
            this.activityNewArr.forEach(item=>{
              item.multi = 0;
            })
            //监听资源位曝光
            this.$nextTick(()=>{
              let _this=this;
              scExposure(".sensor_xrl",function(index){
                let ylyx_resource_forward_url='';
                if (_this.$route.query.name) {
                  ylyx_resource_forward_url=`/item/itemPage/${_this.activityNewArr[index].listingId}?name=${_this.$route.query.name}&latng=${_this.$route.query.latng}&addr=${_this.$route.query.addr}&city=${_this.$route.query.city}&module=${_this.$route.query.module}&freshActType=${_this.freshActType}`
                } else {
                  ylyx_resource_forward_url=`/item/itemPage/${_this.activityNewArr[index].listingId}?freshActType=${_this.freshActType}`
                }
                window.uleStatUtil && window.uleStatUtil.sendSensorTrack("ylyx_ResourceExposure", {
                  ylyx_resource_ower:'试点版',
                  ylyx_resource_type: '新人礼',
                  ylyx_resource_content: _this.activityNewArr[index].title || '',
                  ylw_resource_out_position: 1,
                  ylw_resource_inner_position: (+index + 1),
                  ylyx_resource_item_type: '商品',
                  ylyx_resource_item_id: _this.activityNewArr[index].listingId,
                  ylyx_resource_forward_url: ylyx_resource_forward_url,
                });
              });
            })
          }
          console.log('activityNewArr===',this.activityNewArr)
          // console.log(res, '新人专享礼2商品')
        },
        () => {
          // console.log('接口错误')
        }
      )
    },
    getPilotCity(adcode){//试点城市
      const curProCode = String(adcode).slice(0,2)+'0000'//转换成省code
      const curCityCode = String(adcode).slice(0,4)+'00'//转换成市code
      console.log('curCityCode===',curCityCode)
      this.curCityCode =  String(adcode).slice(0,4)+'00'//转换成市code
      pilotCityListNew(curProCode).then(
        (res) => {
          // eslint-disable-next-line no-unused-expressions
          if(res.code == '0000' && res.data['ylyx_index_city_lists_' + curProCode] && res.data['ylyx_index_city_lists_' + curProCode].length){
            res.data['ylyx_index_city_lists_' + curProCode].map((el) => {
              const item = el.customAttribute
              if(item.codeType == 0){//区
                if(item.code == adcode){
                  this.ispioltCity = true
                  this.freshActType = '1'
                }
              } else if(item.codeType == 1){//市
                if(item.code == curCityCode){
                  this.ispioltCity = true
                  this.freshActType = '1'
                }
              } else if(item.codeType == 2){//省
                if(item.code == curProCode){
                  this.ispioltCity = true
                  this.freshActType = '1'
                }
              }
            });
          }
          // 非试点城市标记
          if(this.$route.query.ispilotcity == 'false') {
              this.ispioltCity = false;
              this.freshActType = ''
          }
          this.setPioltCity(this.ispioltCity)
          document.cookie = `ispioltCity=${this.freshActType};domain=.${uleUrl()};path=/;`
          this.getCartNumbers(); // 购物车数量
          if(this.ispioltCity){
            // this.selfPickupSite(curCityCode);
            this.selfPickupSite(curCityCode);
            this.getacvtivityInfo(curCityCode)
            this.getNewBanner(curCityCode)
            this.getNewBanner2(curCityCode)
            this.getDayHotGood(curCityCode)
            this.getPilotMiddleBanners(adcode); // 中间层banner
          } else {
            this.getPageData(adcode);
          }
          if (window.uleStatUtil) {
            window.uleStatUtil.sendView(location.href, {
              relateType: 'ylxdsqHome',
              relateId1: adcode,
              relateId2: curCityCode,
              relateId3: (this.ispioltCity) ? '试点城市' : ''
            })
          }
          if(this.ispioltCity){
            this.isShowEnvelopes = false;
          }else{
            // 非试点获取红包
            this.getHomePop();
          }
          // console.log(res, '查询试点城市')
        },
        () => {
          // console.log('接口错误')
        }
      )
    },
    getDayHotGood(adcode){//每日爆品接口
      let now=(new Date()).valueOf();
      DayHotGood(adcode).then(
        (res) => {
          if(res.code == '0000' && res.data.length){
            res.data.map((item) => {
              item.buyNum = item.totalSold + item.orderCoefficient * item.orderBaseValue;
              //有新人礼活动且在活动时间内显示活动价格，限时抢购商品直接显示活动期的抢购价
              if(item.promotionDesc){
                //商品有活动
                let promotionDesc=JSON.parse(item.promotionDesc);
                if(now>=promotionDesc.startTime && now<=promotionDesc.endTime){
                  //商品在活动期内
                  if(item.promotionIds.indexOf("6202")>-1 || (item.promotionIds.indexOf("6203")>-1&&this.isNewCustomer)){
                    item.membershipPrice= promotionDesc.itemInfo[0].membershipPrice;
                  }else{
                    //显示原价
                    item.membershipPrice=item.salePrice.split('.')[0]+'.'+item.salePrice.split('.')[1];
                  }
                }else{
                  item.membershipPrice=item.salePrice.split('.')[0]+'.'+item.salePrice.split('.')[1];
                }
              }else{
                item.membershipPrice=item.salePrice.split('.')[0]+'.'+item.salePrice.split('.')[1];
              }
              if(item.dayLimitNum > 0 && item.durationLimitNum == 0){
                item.hotMax = item.dayLimitNum
              }
              else if(item.dayLimitNum == 0 && item.durationLimitNum > 0){
                item.hotMax = item.durationLimitNum
              }
              else if(item.dayLimitNum > 0 && item.durationLimitNum > 0){
                item.hotMax = item.durationLimitNum
              }
            })
            this.dayHotList = res.data
            //监听资源位曝光
            this.$nextTick(()=>{
              let _this=this;
              scExposure(".sensor_bp",function(index){
                let ylyx_resource_forward_url='';
                if (_this.$route.query.name) {
                  ylyx_resource_forward_url=`/item/itemPage/${_this.dayHotList[index].listingId}?name=${_this.$route.query.name}&latng=${_this.$route.query.latng}&addr=${_this.$route.query.addr}&city=${_this.$route.query.city}&module=${_this.$route.query.module}&freshActType=${_this.freshActType}`
                } else {
                  ylyx_resource_forward_url=`/item/itemPage/${_this.dayHotList[index].listingId}?freshActType=${_this.freshActType}`
                }
                window.uleStatUtil && window.uleStatUtil.sendSensorTrack("ylyx_ResourceExposure", {
                  ylyx_resource_ower:'试点版',
                  ylyx_resource_type: '每日爆品',
                  ylyx_resource_content: _this.dayHotList[index].title || '',
                  ylw_resource_out_position: 6,
                  ylw_resource_inner_position: (+index + 1),
                  ylyx_resource_item_type: '商品',
                  ylyx_resource_item_id: _this.dayHotList[index].listingId,
                  ylyx_resource_forward_url: ylyx_resource_forward_url,
                });
              });
            })
          }
          // console.log(res, '每日爆品')
        },
        () => {
          console.log('接口错误')
        }
      )
    },
    getSecKillGood(){//限时秒杀商品
      const params = {
        themeCode:this.discountThemeCode,
        activitySize:5,
        itemSize:12
      }
      SecKillGood(params).then(
        (res) => {
          if(res.code == '0000'&& res.content){
            res.content.forEach((item,index) => {
              console.log('item=====',item)
              let satrt = new Date(item.startTime.replace(/-/g, "/")).getTime(),
                  end = new Date(item.endTime.replace(/-/g, "/")).getTime();
              if(this.nowTime < satrt){// 开始时间大于当前时间 未开始
                item.className = 'before'
                item.status = '待开抢'
              }
              if(this.nowTime >= satrt && this.nowTime < end ){// 开始时间小于当前时间并且结束时间大于当前时间 进行中
                item.className = 'ing'
                item.status = '抢购中'
                item.show = true
                this.seckillIndex = index
              }
              if(this.nowTime > satrt && this.nowTime >= end){// 已结束
                item.className = 'over'
                item.status = '已结束'
              }
              this.secKillTime.push({
                'satrt':'',
                'startTime':item.startTime.split(' ')[1].slice(0,5),
                'itemList':item.itemList,
                'className':item.className,
                'status':item.status,
                'show':item.show,
                'multi':0
              })
              // console.log('secKillTime====',this.secKillTime)

            })
            this.secKillTime.sort((n1,n2) => {
              return n1.satrt -n2.satrt
            })
            // 如果当前的不是第一个
            console.log('seckillIndex====',this.seckillIndex)
           if(this.secKillTime.length ==2){
              if(this.seckillIndex !=0){
                this.newSecKillList.push(this.secKillTime[this.seckillIndex -1])
                this.newSecKillList.push(this.secKillTime[this.seckillIndex])
              }
           }
           else if(this.secKillTime.length >2 && this.seckillIndex +1 != this.secKillTime.length){
            if(this.seckillIndex !=0){
              this.newSecKillList.push(this.secKillTime[this.seckillIndex -1])
              this.newSecKillList.push(this.secKillTime[this.seckillIndex])
              this.newSecKillList.push(this.secKillTime[this.seckillIndex+1])
            }
            else if(this.seckillIndex == 0){
              this.newSecKillList.push(this.secKillTime[this.seckillIndex])
              this.newSecKillList.push(this.secKillTime[this.seckillIndex+1])
              this.newSecKillList.push(this.secKillTime[this.seckillIndex+2])
            }
          }else if(this.secKillTime.length >2 && this.seckillIndex +1 == this.secKillTime.length){
            this.newSecKillList.push(this.secKillTime[this.seckillIndex -2])
            this.newSecKillList.push(this.secKillTime[this.seckillIndex -1])
            this.newSecKillList.push(this.secKillTime[this.seckillIndex])
          }
            console.log('newSecKillList===',this.newSecKillList)
            console.log('secKillTime===',this.secKillTime)
            if(this.seckillIndex +1 == this.secKillTime.length){
            this.seckillIndex = 2;
            }
            //监听资源位曝光
            this.$nextTick(()=>{
              let _this=this;
              scExposure(".sensor_ms",function(index){
                let ylyx_resource_forward_url='';
                let data=_this.newSecKillList[seckillIndex].itemList;
                if (_this.$route.query.name) {
                  ylyx_resource_forward_url=`/item/itemPage/${data[index].listingId}?name=${_this.$route.query.name}&latng=${_this.$route.query.latng}&addr=${_this.$route.query.addr}&city=${_this.$route.query.city}&module=${_this.$route.query.module}&freshActType=${_this.freshActType}`
                } else {
                  ylyx_resource_forward_url=`/item/itemPage/${data[index].listingId}?freshActType=${_this.freshActType}`
                }
                window.uleStatUtil && window.uleStatUtil.sendSensorTrack("ylyx_ResourceExposure", {
                  ylyx_resource_ower:'试点版',
                  ylyx_resource_type: '限时秒杀',
                  ylyx_resource_content: data[index].title || '',
                  ylw_resource_out_position: 4,
                  ylw_resource_inner_position: (+index + 1),
                  ylyx_resource_item_type: '商品',
                  ylyx_resource_item_id: data[index].listingId,
                  ylyx_resource_forward_url: ylyx_resource_forward_url,
                });
              });
            })
          }
          // console.log(res, '限时秒杀')
        },
        () => {
          // console.log('接口错误')
        }
      )
    },
    getacvtivityInfo(adcode){//获取优惠券批次号，活动code，主题code
      acvtivityInfo(adcode).then(
        (res) => {
          if(res.code == '0000'){
              this.discountActivityCode = res.data.discountActivityCode
              this.couponCode = res.data.couponCode
              this.discountThemeCode = res.data.discountThemeCode//getSecKillGood
              this.newRuleCode = res.data.newRuleCode;
            if(!checkUserStatus()){//判断是否登录
              this.isNewUserFlag = true
            } else {
              this.isNew()//isNew
            }
            if(res.data.couponCode) {
              this.getcouponBridgeList()
            }
            if(res.data.discountActivityCode) this.getactivityNew()
            if(res.data.discountThemeCode) this.getSecKillGood()
          }
          
        },
        () => {
          // console.log('接口出错')
        }
      )
    },
    getcouponBridgeList(){
      queryCouponList(this.couponCode).then(
        (res) => {
          if(res.code == '0000' && res.content &&res.content.prizeCouponDetails){
            res.content.prizeCouponDetails.map((item) => {
              this.batchidList.push({
                batchIdCipher:item.batchIdCipher,
                receiveCount:1
              })
              this.couponBatchIds += item.batchIdCipher + ','
            })
            // console.log(this.batchidList)
            this.getserchCoupon()
          }
          // console.log(res,'查券中间新增')
        },
        () => {
          // console.log('接口错误')
        }
      )
    },
    getserchCoupon(){//查询优惠券
      const params = {
        businessType:'4',
        pageIndex:1,
        pageSize:5,
        batchIdCipher:this.couponBatchIds,
        showChannelCode:'activity'
      }
      serchCoupon(params).then(
        (res) => {
          if(res.code == '0000' && res.returnMsg.couponList){
            res.returnMsg.couponList.map((item) => {
              if(parseInt(item.fullCutAmount) == 0){
                item.text = ''
              } else {
                item.text = '满'+ item.fullCutAmount+'元可用'
              }
            })
            this.couponList = res.returnMsg.couponList
          }
          // console.log(res,'查询优惠券')
        },
        () => {
          // console.log('接口错误')
        }
      )
    },
    getCoupon(){//一键领取优惠券
      if(!checkUserStatus()){
        let targetUrl = `https://h5.${this.$uleUrl()}/yxd/community`;
        targetUrl = `${targetUrl}${this.$route.fullPath}`;
        window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(targetUrl)}`;
        return
      }
      const params = {
        batchInfos:JSON.stringify(this.batchidList),
        activityCode:this.couponCode,
        channel:'610003'
      }
      if(this.$browser().miniprogram) params.channel = '610001'
      getAllCoupon(params).then(
        (res) => {
          if(res.code == '0000'){
            this.$toast('恭喜您领取成功！请在‘我的优惠券’查看并使用！')
          } else {
            this.$toast(res.message)
          }
          // console.log(res,'领取优惠券')
        },
        () => {
          // console.log('接口错误')
        }
      )
    },
    // 更多秒杀
    toMoreLimit(){
      this.toNext('/limit/list',{curCityCode:this.curCityCode})
    },
    //查询是否为新人用户
    queryIsNewCustomer(){
      return isNewUserForVI().then(
        (res) => {
          if(res.code == '0000'){
            if(res.data.new){
              localStorage.setItem('isNewCustomer',1);//新人标识是1
            }else{
              localStorage.setItem('isNewCustomer',2);//不是新人标识是2
            }
            return res.data.new;
          }
          // console.log(res, '判断新人接口')
        },
        () => {
          // console.log('接口错误')
        }
      )
    },
    //banner点击神策埋点
    sensorClick(item,index){
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_ResourceClick', {
        ylyx_resource_ower: '非试点版',
        ylyx_resource_type: '首页轮播图',
        ylyx_resource_content: item.title,
        ylw_resource_out_position: 1,
        ylw_resource_inner_position: (+index + 1),
        ylyx_resource_item_type: 'Banner',
        ylyx_resource_item_id: '',
        ylyx_resource_forward_url: item.customAtt_link,
        ul_aid:`yxhome_banner_${item.title || item.customTitle || ''}`
      });
    },
    // 红包弹层关闭
    closeEnvelopesPop(){
      this.isShowEnvelopes = false;
      this.isShowRedIcon = true;
    },
    // 红包抽奖
    handleLottry(){
      if(!checkUserStatus()){
        this.handleToLogin()
      }else{
        console.log('抽奖');
        let params = {
          // activityCode: 'MA_U_167152862678267',
          activityCode: this.activityCode,
          channel: '610003',
          fieldId:'',
          deviceId:''
        };
        lottryV2Api(params).then(res => {
          this.canLottry = false;
          if (res.code == '0000') {
            // 如果抽中
            this.isSuccess = true;
            this.prizeData = res.content.prizeInfos[0];
          }else{
            this.isSuccess = false;
          }
        });
      }
    },
    // 浮层点击
    handleShowEnvelopes(){
      if(!checkUserStatus()){
        this.handleToLogin()
      }else{
        freshHomePopApi({ visualChannel: 'miniwx_ylxdsq' }).then(res => {
          if (res.code == '0000') {
             let data = res.content.listPop;
              // 有活动
              if (data.length > 0) {
                if (data[0].times > 0) {
                  this.canLottry = true;
                  this.activityCode = data[0].activity_code;
                  this.activityStartTime = data[0].activity_time.split('#')[0];
                  this.activityEndTime = data[0].activity_time.split('#')[1];
                  let now = this.$moment(this.systemTime).format('YYYYMMDD');
                  let endTime =  this.$moment(this.activityEndTime).format('YYYYMMDD');
                  if(now == endTime){
                    this.isLast = true;
                  }else{
                    this.isLast = false;
                  }
                  this.isShowEnvelopes = true;
                  this.isShowRedIcon = false;
                } else {
                  this.canLottry = false;
                  this.isShowEnvelopes = true;
                  this.isShowRedIcon = false;
                  this.resultText = '当日福袋活动已参与'
                }
              }
          }
        })
      }
    },
     // 获取弹窗信息
     getHomePop() {
      freshHomePopApi({ visualChannel: 'wap_ylxdsq' }).then(res => {
        if (res.code == '0000') {
          let data = res.content.listPop;
          // 有活动
          if (data.length > 0) {
            // 未抽过
            if (data[0].times > 0) {
              this.canLottry = true;
              this.activityCode = data[0].activity_code;
              this.activityStartTime = data[0].activity_time.split('#')[0];
              this.activityEndTime = data[0].activity_time.split('#')[1];
              let now = this.$moment(this.systemTime).format('YYYYMMDD');
              let endTime =  this.$moment(this.activityEndTime).format('YYYYMMDD');
              if(now == endTime){
                this.isLast = true;
              }else{
                this.isLast = false;
              }
              this.isShowEnvelopes = true;
              this.isShowRedIcon = false;
            } else if (data[0].totalTimes>0) {
              this.isShowEnvelopes = false;
              this.isShowRedIcon = true;
            } else {
              this.canLottry = false;
              this.isShowEnvelopes = false;
              this.isShowRedIcon = false;
            }
          }
          // 没有活动
          else {
            this.isShowEnvelopes = false;
            this.isShowRedIcon = false;
          }
        } else {
          this.isShowEnvelopes = false;
          this.isShowRedIcon = false;
        }
      });
    },
    // 未登录跳转
    handleToLogin() {
      let targetUrl = `${this.targetUrl}${this.$route.fullPath}`;
      this.$dialog
        .confirm({
          title: "提示",
          message: "请先登录",
        })
        .then(() => {
          if (this.$browser().miniprogram) {
            window.wx.miniProgram.navigateTo({
              url:
                "/pages/authorize?target=" +
                encodeURIComponent(targetUrl) +
                "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
            });
          } else {
            window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(
              targetUrl
            )}`;
          }
        })
        .catch(() => {});
    },
     // 红包雨倒计时
     rainFinish() {
      console.log('rainFinish');
      this.floatImg = this.rainImg;
      this.floatUrl = this.rainUrl;
      console.log(this.rainImg)
    },
    // 红包雨数据
    getRainPop() {
      queryActCodeByThemeCodeApi({ channel: 'wap_ylxdsq', rtnUserRole: '1' }).then(res => {
        if (res && res.code == '0000') {
          if (res.data) {
            let userRole = res.data[0].userRole;
            console.log('userRole', userRole);
            let currentDate = this.$moment(this.systemTime).format('YYYY-MM-DD HH:mm:ss'); // 当前时间
            let currentFieldInfos = [],
              conformFieldInfos = [],
              nullFieldInfos = [],
              timerList = [],
              conformImg = '',
              conformUrl = '',
              nullImg = '',
              nullUrl = '';
            console.log(currentDate, 'currentDate');
            res.data.forEach(item => {
               // vip会员
               if (item.userLimit == '103' && (userRole == '1' || userRole == '2')) {
                if (item.fieldInfos.length > 0) {
                  conformFieldInfos = item.fieldInfos;
                  conformImg = item.float_pic;
                  conformUrl = item.activityUrl;
                }
              }
              // 普通会员
              else if (item.userLimit == '0' && (userRole == '0' || userRole == '3')) {
                if (item.fieldInfos.length > 0) {
                  conformFieldInfos = item.fieldInfos;
                  conformImg = item.float_pic;
                  conformUrl = item.activityUrl;
                }
              }
              // 默认全部
              if (item.userLimit == null || item.userLimit == '') {
                if (item.fieldInfos.length > 0) {
                  nullFieldInfos = item.fieldInfos;
                  if (userRole == '1' || userRole == '2') {
                    nullImg = item.float_pic;
                  } else {
                    nullImg = item.float_pic;
                  }
                  nullUrl = item.activityUrl;
                }
              }
            });

            console.log('与身份相符的场次', conformFieldInfos);
            console.log('全部能参加的场次', nullFieldInfos);
            // currentFieldInfos = conformFieldInfos || nullFieldInfos || [];
            if (conformFieldInfos.length > 0) {
              currentFieldInfos = conformFieldInfos;
            } else if (nullFieldInfos.length > 0) {
              currentFieldInfos = nullFieldInfos;
            } else {
              currentFieldInfos = [];
            }
            this.rainImg = conformImg || nullImg || '';
            this.rainUrl = conformUrl || nullUrl || '';

            console.log('currentImg', this.rainImg);
            console.log('currentUlr', this.rainUrl);
            if(this.rainUrl) {
              if (this.rainUrl.indexOf('?') > -1) {
                this.rainUrl = `${this.rainUrl}&storeid=${this.store_id}&shareId=${this.$route.query.shareId}`;
              } else {
                this.rainUrl = `${this.rainUrl}?storeid=${this.store_id}&shareId=${this.$route.query.shareId}`;
              }
            }
            console.log('当前时间段的场次', currentFieldInfos);
            if (currentFieldInfos.length > 0) {
              if (currentFieldInfos[currentFieldInfos.length - 1] > currentDate) {
                currentFieldInfos.forEach(item => {
                  if (currentDate > item.startTime && currentDate <= item.endTime) {
                    console.log('直接弹');
                    this.floatImg = this.rainImg;
                    this.floatUrl = this.rainUrl;
                  } else if (currentDate < item.startTime) {
                    console.log('获取当前item开始倒时计', item);
                    timerList.push(item);
                  }
                });
              }
              console.log('timerList', timerList);
              if (timerList.length > 0) {
                this.rainTime = this.$moment(timerList[0].startTime).diff(this.systemTime);
                // this.rainTime = this.$moment('2023-11-03 17:22:00').diff(this.$moment());
                // console.log('this.$moment()',timerList[0].startTime)
              }
            }
          }
        }
      });
    },
    // 新人礼点击
    handleToNew() {
      this.isShowNew = false;
      if (this.newData.h5_url) {
        console.log('跳转链接=====', this.newData.h5_url);
        window.location.href = this.newData.h5_url;

      }
    },
     // 新人礼弹层
     getNewData() {
      freshPopAndFloatApi({ visualChannel: 'wap_ylxdsq' }).then(res => {
        if (res && res.code == '0000') {
          if (res.content && res.content.listPop.length > 0) {
            this.newData = res.content.listPop[0];
            let popType = this.newData.pop_type; // 弹框类型 1-每天弹 2-活动期间弹
            let popTypeParam = this.newData.pop_type_param;
            let today = this.$moment().format('YYYYMMDD');
            let popDay = localStorage.getItem('popDay');
            let activityTime = [];
            if (this.newData.activity_time) {
              activityTime = this.newData.activity_time.split('#');
            }
            console.log('activityTime====', activityTime);
            console.log('popType====', popType);
            console.log('popTypeParam====', popTypeParam);
            // 每天弹
            if (popType == 1) {
              if (popDay) {
                let popDayParam = localStorage.getItem('popDayParam');
                if (popDay != today) {
                  this.isShowNew = true;
                  localStorage.setItem('popDay', today);
                  localStorage.setItem('popDayParam', 1);
                } else {
                  if (popDayParam >= popTypeParam) {
                    this.isShowNew = false;
                  } else {
                    this.isShowNew = true;
                    localStorage.setItem('popDayParam', popDayParam + 1);
                  }
                }
              } else {
                this.isShowNew = true;
                localStorage.setItem('popDay', today);
                localStorage.setItem('popDayParam', 1);
              }
            }
            // 活动期间弹
            else if (popType == 2) {
              let currentDate = this.$moment(this.systemTime).format('YYYY-MM-DD HH:mm:ss'); // 当前时间
              // 在活动期间
              if (currentDate > activityTime[0] && currentDate < activityTime[1]) {
                let popActivityParam = localStorage.getItem('popActivityParam');
                if (popActivityParam) {
                  if (popActivityParam >= popTypeParam) {
                    this.isShowNew = false;
                  } else {
                    this.isShowNew = true;
                    localStorage.setItem('popActivityParam', popActivityParam + 1);
                  }
                } else {
                  this.isShowNew = true;
                  localStorage.setItem('popActivityParam', 1);
                }
              } else {
                this.isShowNew = false;
              }
            }
            // this.isShowNew = true;
          } else {
            this.isShowNew = false;
          }
        } else {
          this.isShowNew = false;
        }
      });
    },

    // 红包雨点击
    handleTobuoy() {
      if (this.rainUrl) {
        console.log('handleTobuoy')
        window.location.href=this.rainUrl;
      }
    },
  },
  created(){
    systemTime(time=>{
      this.systemTime = time;
    })
  },
  async mounted() { 
    //2022.7.27pm需求暂无新人商品所以先不调用新人身份查询接口，
    let isNewCustomer=localStorage.getItem('isNewCustomer');
    if(!isNewCustomer || isNewCustomer==1){
      this.isNewCustomer=await this.queryIsNewCustomer();//查询是否为新人用户
    }
    localStorage.setItem('isNewCustomer',2);//直接设置身份为老用户
    this.store_id = this.$route.query.store_id || this.$route.query.storeid || this.getStorage("user", "user.STORE_ID") || "";
    if (~(this.store_id + "").indexOf("=")) {
      //处理已产生的store_id 带等号的问题
      this.store_id = this.store_id.split("=")[1];
    }
    if (this.store_id === "false") {
      //处理已产生的store_id 等于'false' 的问题
      this.store_id = "";
    }
    this.nowTime = new Date().getTime()
    // 小程序环境
    if (this.$browser().miniprogram) {
      let arr = (this.getCurrentCityByMin.location || '').split(',')
      this.querySiteParams.latitude = arr[0];
      this.querySiteParams.longitude = arr[1]
      this.querySiteParams.areaId = this.getCurrentAdCodeByMin;
      this.querySiteParams.cityId = this.getCurrentAdCodeByMin;
      this.minMessage.title = "邮乐优鲜";
      this.minMessage.desc = "邮乐优鲜";
      this.minMessage.link = this.getCurrentLink(`https://h5.${this.$uleUrl()}/yxd/community/`);
      this.minMessage.imgUrl = this.topBanner[0];
      window.wx.miniProgram.postMessage({ data: this.minMessage });
      this.getPilotCity(this.getCurrentAdCodeByMin)
    }
    // H5环境
    else {
      // console.log('H5环境===============')
      window.setWeiXinShare({
        title: "邮乐优鲜",
        desc: "邮乐优鲜",
        link: this.getCurrentLink(`https://h5.${this.$uleUrl()}/yxd/community/`),
        imgUrl: this.topBanner[0],
      });
      if (this.getCurrentAdCode) {
        let arr = (this.getCurrentCity.location || '').split(',')
        this.querySiteParams.latitude = arr[0];
        this.querySiteParams.longitude = arr[1]
        this.querySiteParams.areaId = this.getCurrentAdCode;
        this.querySiteParams.cityId = this.getCurrentAdCode;
        this.getPilotCity(this.getCurrentAdCode)
        // this.getRecommend();
      } else {
        this.$router.push("/others/positionLost");
      }
    }
    console.log('当前定位信息',this.querySiteParams)
    if(checkUserStatus()){
      console.log('登录')
      // this.getRainPop();
    }
    this.getNewData();
  },
      
};
